import {
    Breadcrumb,
    Button,
    Checkbox,
    Col,
    Drawer,
    Dropdown,
    Empty,
    Form, FormInstance,
    Input,
    Menu,
    Modal,
    Pagination,
    Popconfirm,
    Radio,
    Row,
    Select,
    Space,
    Table,
    Tag,
    TimePicker,
    notification
} from "antd";
import React from "react";
import { connect } from "react-redux";
import { NavLink, RouteComponentProps } from "react-router-dom";
import { RootStoreModel } from "../../../redux/reducers";
import {
    BasicStateForListModel
} from "../../models";

import {
    AndroidFilled,
    AppleFilled, DeleteOutlined,
    DownOutlined,
    PlusOutlined,
    createFromIconfontCN
} from '@ant-design/icons';
import dayjs from 'dayjs';
import {
    addCommandPolicy,
    deleteCommandPolicy,
    getCommandPolicy,
    getCommandPolicyList,
} from "../../../axios/api.device";

import { Translation } from "react-i18next";
import { MacCommandPolicyCustomScript } from "./mac.commandPolicy.customScript";
import { MacCommandPolicyLocalAccount } from "./mac.commandPolicy.localAccount";

const {Column} =Table
const { SubMenu } = Menu;
const { Item } = Form;
const MyIcon = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2670925_pf3sykyocl.js', // 在 iconfont.cn 上生成
});
interface stateModel extends BasicStateForListModel {
    name: string,
    current: string,
    selectTemplate: string,
    isShowTable: boolean,
    search: string,
    isShowAddForm: boolean,
    selectRow: any,
    showRightBox: boolean
    selectDevices: any[],
    currentName: string,
    templateTabs: any[],
    dropdownVisible: any[],
    isModify: boolean,
    templateItemsStatus: any,
    templateItemsMap: any,
    isSelectdItem: boolean,
    templateSelectItemsMap: any,
    platform:string,
    brand:string
}
interface propsModel extends RouteComponentProps<any, any, any> {
    tokenSuccess: boolean
}
const mapStatetoProps = (state: RootStoreModel) => ({
    tokenSuccess: state.userState.tokenSuccess
});

class MacCommandPolicyIndex extends React.Component<propsModel, stateModel> {
    formRef = React.createRef<FormInstance>();
    constructor(props: propsModel) {
        super(props);
        this.state = {
            name: "MacCommandPolicyIndex",
            current: "CustomScript",
            currentName: "",
            selectTemplate: "",
            isShowTable: true,
            pageIndex: 1,
            pageSize: 10,
            totalCount: 0,
            search: "",
            loading: false,
            data: [],
            columns: [],
            isShowAddForm: false,
            selectRow: {},
            showRightBox: false,
            selectDevices: [],
            templateTabs: [],
            dropdownVisible: [],
            isModify: false,
            isSelectdItem: false,
            platform: "",
            brand:"",
            templateItemsStatus: {
                CustomScript: false,
                LocalAccount: false
            },
            templateItemsMap: {
                CustomScript: "CustomScript",
                LocalAccount: "LocalAccount"
            },
            templateSelectItemsMap: {
                CustomScript: "CustomScript",
                LocalAccount: "LocalAccount"
            }
        }
    }
    Init() {
        this.getList();
        console.log("statessss",this.props.history.location.state);
        if (this.props.history.location.state && Object.keys(this.props.history.location.state).length > 0) {
            this.operationClick({key: 'edit'}, this.props.history.location.state);
        }
    }
    componentDidMount() {
        if (this.props.tokenSuccess) {
            this.Init();
        }

    }
    componentDidUpdate(prevProps: propsModel) {
        if (this.props.tokenSuccess !== prevProps.tokenSuccess) {
            this.Init();
        }
    }

    deviceHandleChange(value: any[]) {
        this.setState({ selectDevices: value });
    }
    getList(pageIndex = this.state.pageIndex,
        pageSize = this.state.pageSize) {
        var temArg = {
            pageIndex: pageIndex,
            pageSize: pageSize,
            search: this.state.search
        }
        getCommandPolicyList(temArg).then(
            (res) => {
                this.setState({
                    data: res.dataList,
                    pageSize: res.pageSize,
                    pageIndex: res.pageIndex,
                    loading: false,
                    totalCount: res.totalCount,
                    dropdownVisible: [],
                });
                res.dataList.forEach((item: any) => {
                    this.state.dropdownVisible.push({key: item.id, value: false});
                });
            })
    }
    templateNameUpdate = (e: any) => {
        console.log(e);
        var sele = {
            name: e.target.value,
            id: this.state.selectRow.id,
            status: this.state.selectRow.status,
        }
        this.setState({ selectRow: sele })
    }

    handleMenuClick = (e: any) => {
        this.setCurrentName(e.key);
        // var currname = "";
        // switch (e.key) {
        //     case "CustomScript":
        //         currname = "自定义脚本"
        //         break;
        //     case "LocalAccount":
        //         currname = "本地账户"
        //         break;
        // }
        // this.setState({ current: e.key, currentName: currname });
    };

    setCurrentName = (key: any) => {
        var currname = "";
        switch (key) {
            case "CustomScript":
                currname = "自定义脚本"
                break;
            case "LocalAccount":
                currname = "本地账户"
                break;
        }
        this.setState({ current: key, currentName: currname });
    };

    onSearch = () => {
        this.getList();

    }

    addTemplateClick = () => {
        this.setState({ loading: true });
        this.formRef.current?.validateFields().then(
            (res) => {
                res.status = "Active";
                var mes = "添加命令策略成功";
                if(this.state.isModify)
                    mes = "编辑命令策略成功";
                addCommandPolicy(res).then(
                    () => {
                        this.getList();
                        this.setState({ isShowAddForm: false });
                        this.formRef.current?.resetFields();
                        console.log("addTemplate",res,this.state.isModify)
                        notification.success({message: <Translation>{t => t(mes)}</Translation>});
                    },
                    () => { notification.error({message: <Translation>{t => t(mes)}</Translation>}) }
                ).finally(
                    () => { 
                        this.setState({
                            loading: false, 
                            isModify: false
                        }) 
                    }
                )
            },
            () => { this.setState({loading: false}) }
        )
    }
    operationClick = (e: any, row: any) => {
        if (!e.key) {
            return
        }
        switch (e.key) {
            case "edit":
                var obj = {current: "CustomScript", name: "自定义脚本"};
                this.formRef.current?.setFieldsValue(row);
                this.setState({ 
                    isShowTable: false, 
                    currentName: obj.name, 
                    current: obj.current,
                    selectRow: row
                });
                this.getSelectedTemplate(row.id);
                this.getList();
                break;
            case "delete":
                deleteCommandPolicy(row.id).then(
                    () => {
                        notification.success({ message: <Translation>{t => {return t("删除成功")}}</Translation> });
                        this.getList();
                    }, 
                    () => { notification.error({ message: <Translation>{t => {return t("删除失败")}}</Translation> }) }
                )
                break;
            case "modify":
                getCommandPolicy(row.id).then(
                    res => {
                        this.formRef.current?.setFieldsValue(row);

                        this.setState({
                            isModify: true, 
                            isShowAddForm: true
                        });
                    },
                    () => {
                        notification.error({message: <Translation>{t => {return t("获取命令策略失败")}}</Translation>})
                    }
                )
                break;
            case "devices":
                this.props.history.push({
                    pathname: `/home/mac/commandPolicy/devices/${row.id}`, 
                    state: row
                });
                break;
        
            default:
                break;
        }
    }
    onClose = () => {
        this.setState({
            showRightBox: false,
        });
    };
    getTemplateTab = () => {
        var tab = this.state.templateTabs.find(c => {
            return c.tabKey === this.state.current;
        })
        return tab;

    }

    getSelectedTemplate = (templateId: string) => {
        this.setState({ isSelectdItem: false });
        getCommandPolicy(templateId).then(
            (res) => {
                const {selectdItemList} = res;
                const {templateSelectItemsMap} = this.state;
                const items: any = {};
                if (selectdItemList.length > 0) {
                    var current = templateSelectItemsMap[selectdItemList[0]]
                    this.setState({ isSelectdItem: true,current: current });
                    this.setCurrentName(current);
                    selectdItemList.forEach((item: any) => {
                        items[item] = true;
                    })
                }
                this.setState({templateItemsStatus: items});
                
            },
            () => { notification.error({message: <Translation>{t => {return t("获取命令策略数据失败")}}</Translation>}) }
        )
    }

    updateTemplate = () => {
        this.getSelectedTemplate(this.state.selectRow.id);   
    }

    render() {
        const { 
            name, current, selectTemplate, isShowTable, templateItemsStatus, 
            templateItemsMap, data, pageIndex, pageSize, totalCount, search, 
            loading, isShowAddForm, selectRow, showRightBox, 
            currentName, dropdownVisible, isModify, isSelectdItem
        } = this.state;
        return (
            (<Translation>{t => {
                    return (
                        (<div>
                            <div className="breadcrumbTop py-2">
                                <Breadcrumb>
                                   
                                    <Breadcrumb.Item>{t("Mac端管")}</Breadcrumb.Item>
                                    <Breadcrumb.Item>  
                                        <a onClick={() => {
                                            this.setState({ 
                                                isShowTable: true, 
                                                currentName: "", 
                                                current: "",
                                                templateItemsStatus: {
                                                    App: false,
                                                    MacAppRestriction: false,
                                                    WebFilter: false,
                                                }, 
                                            });
                                            this.props.history.replace("/home/mac/commandPolicy/index");
                                        }}>{t("命令策略")}</a>
                                    </Breadcrumb.Item>
                                    {currentName?.trim() ? <Breadcrumb.Item>{t(currentName)}</Breadcrumb.Item> : null}
                                </Breadcrumb>
                                {!currentName && (
                                    <Row style={{padding: "32px 0 11px 0"}}>
                                        <Space>
                                            <img src="/images/profileIcon.svg" alt="" />
                                            <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("命令策略")}</span>
                                        </Space>
                                    </Row>
                                )}
                            </div>
                            <Row style={{ width: "100%" }}>
                                {!isShowTable && (
                                    <div className="borderBox">
                                        <Row style={{height: "36px", borderBottom: "1px solid #F1F1F1"}}>
                                            <Col span={4} style={{textAlign: "center", marginTop: "-3px"}}>
                                                {selectRow.platform === 'macOS' && (
                                                    <AppleFilled style={{fontSize: 20}}></AppleFilled>
                                                )}
                                                <span style={{
                                                    fontSize: "16px",
                                                    fontWeight: 600,
                                                    marginLeft: "10px",
                                                }}>{selectRow.name}</span>
                                            </Col>
                                            <Col span={20}>
                                                <NavLink style={{marginLeft: "16px"}} to={{
                                                    pathname: `/home/mac/commandPolicy/devices/${selectRow.id}`, 
                                                    state: selectRow, 
                                                }}>
                                                    <img src="../../images/App.png" style={{marginTop: "-3px"}} alt="" />
                                                    <span>{t("关联设备")}</span>
                                                </NavLink>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={4}>
                                                <Menu mode="inline" defaultSelectedKeys={['CustomScript']} defaultOpenKeys={['CustomScript']}
                                                    onClick={this.handleMenuClick} selectedKeys={[current]}
                                                >
                                                    <Menu.Item key="CustomScript"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["CustomScript"]]}>
                                                        <div style={{display: "flex", justifyContent: "space-between"}}>
                                                            <span>{t("自定义脚本")}</span> 
                                                            {templateItemsStatus[templateItemsMap["CustomScript"]] && <img src="../../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                        </div>
                                                    </Menu.Item>
                                                    <Menu.Item key="LocalAccount"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["LocalAccount"]]}>
                                                        <div style={{display: "flex", justifyContent: "space-between"}}>
                                                            <span>{t("本地账户")}</span> 
                                                            {templateItemsStatus[templateItemsMap["LocalAccount"]] && <img src="../../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                        </div>
                                                    </Menu.Item>
                                                </Menu>
                                            </Col>
                                            <Col span={20}>
                                                {current === "CustomScript" && (
                                                    <MacCommandPolicyCustomScript policyId={selectRow.id} templateTab={this.getTemplateTab()} updatePolicy={this.updateTemplate}></MacCommandPolicyCustomScript>
                                                )}
                                                {current === "LocalAccount" && (
                                                    <MacCommandPolicyLocalAccount policyId={selectRow.id} templateTab={this.getTemplateTab()} updatePolicy={this.updateTemplate}></MacCommandPolicyLocalAccount>
                                                )}
                                            </Col>
                                        </Row>
                                    </div>
                                )}
                                {isShowTable && (
                                    <>
                                        <div className="borderBox">
                                            <Row  className="mb-3">
                                                <Col > 
                                                {t("命令策略名称")}:
                                                <Input placeholder="" value={search}
                                                style={{ width: "200px", marginLeft: 10 }}
                                                    onChange={(e) => this.setState({ search: e.target.value })} /></Col>
                                                <Col offset={1}>
                                                    <Button type="primary" onClick={() => { this.onSearch(); }}>
                                                        {t("查询")}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div className="borderBox">
                                            <Row>
                                                <Col className="ms-auto" style={{ marginBottom: 8 }}>  <Button type="primary"
                                                    onClick={() => { this.setState({ isShowAddForm: true }) }}><PlusOutlined />{t("添加")} {t("命令策略")}</Button></Col>
                                            </Row>
                                            <Row  >
                                                <Col span={24}>
                                                    <Table 
                                                        size="middle" 
                                                        dataSource={data} 
                                                        rowKey={recored => recored.id} 
                                                        style={{ width: "100%", minHeight: 300 }} 
                                                        pagination={false}
                                                        locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                                                    >
                                                        <Column
                                                            title={t("命令策略名称")}
                                                            key="name"
                                                            dataIndex="name"
                                                        ></Column>
                                                        <Column
                                                            title={t("创建时间")}
                                                            key="createTime"
                                                            dataIndex="createTime"
                                                        ></Column>
                                                        <Column
                                                            title={t("最近修改时间")}
                                                            key="updateTime"
                                                            dataIndex="updateTime"
                                                        ></Column>
                                                        <Column
                                                            title={t("关联设备")}
                                                            key="deviceCount"
                                                            dataIndex="deviceCount"
                                                            align="center"
                                                            render={(v, row: any, index) => {
                                                                return (
                                                                    <NavLink to={{ pathname: `/home/mac/commandPolicy/devices/${row.id}`, state: row }} >{v}</NavLink>
                                                                )
                                                            }}
                                                        ></Column>
                                                        <Column
                                                            title={t("操作")}
                                                            key="id"
                                                            dataIndex="id"
                                                            align="center"
                                                            render={(v, raw, index) => {
                                                                return (
                                                                    <Dropdown
                                                                        open={dropdownVisible.length > 0 && dropdownVisible[index]['value']}
                                                                        onOpenChange={(visible) => {
                                                                            const tempList: any[] = [];
                                                                            dropdownVisible.forEach((item) => {
                                                                                if (item.key === v) {
                                                                                    item['value'] = visible;
                                                                                }
                                                                                tempList.push(item);
                                                                            })
                                                                            this.setState({dropdownVisible: tempList});
                                                                        }}
                                                                        // trigger={['click']}
                                                                        dropdownRender={() => (
                                                                            <Menu onClick={(res) => this.operationClick(res, raw)}>
                                                                                <Menu.Item key='edit'>{t("编辑明细")}</Menu.Item>
                                                                                <Menu.Item key='modify'>{t("基本信息")}</Menu.Item>
                                                                                <Menu.Item key='devices'>{t("关联设备")}</Menu.Item>
                                                                                <Popconfirm title={"确认删除?"} onConfirm={() => this.operationClick({key: 'delete'}, raw)}>
                                                                                    <Menu.Item key='delete' className="custom-menu-item">{t("删除")}</Menu.Item>
                                                                                </Popconfirm>
                                                                            </Menu>
                                                                        )}>
                                                                        <a>{t("更多")}<DownOutlined /></a>
                                                                    </Dropdown>
                                                                )
                                                            }}></Column>
                                                    </Table>
                                                    <Pagination
                                                        style={{ textAlign: "right", marginTop: "20px" }}
                                                        pageSize={pageSize}
                                                        current={pageIndex}
                                                        total={totalCount}
                                                        showTotal={(total, range) =>
                                                            `${range[0]}-${range[1]} / ${total} ${t("条")}`
                                                        }
                                                        onChange={(page, pageSize) => {
                                                            this.getList(page, pageSize);
                                                        }}
                                                        onShowSizeChange={(current, size) => this.getList(current, size)}
                                                    ></Pagination>
                                                </Col>
                                            </Row>
                                            <Modal
                                                confirmLoading={loading}
                                                maskClosable={false}
                                                open={isShowAddForm}
                                                destroyOnClose={true}
                                                title={`${isModify ? "" : t("添加")} ${t("命令策略")}`}
                                                forceRender={true}
                                                width={"650px"}
                                                onOk={() => { this.addTemplateClick() }}
                                                onCancel={() => {
                                                    this.setState({ 
                                                        isShowAddForm: false,
                                                        isModify: false, 
                                                        loading: false
                                                    });
                                                    this.formRef.current?.resetFields();
                                                }}
                                                okText={t("确认")}
                                                cancelText={t("取消")}
                                            >
                                                <Form
                                                    // labelCol={{ span: 6 }}
                                                    ref={this.formRef}
                                                    layout="vertical"
                                                    initialValues={{ name: "", executionFrequency: "No",failedRetryCount: 0,checkFrequency:60,isSelfService: true }}
                                                >
                                                    <Item label="ID" name="id" hidden>
                                                        <Input></Input>
                                                    </Item>
                                                    <Item label={t("命令策略名称")} name="name" rules={[{ required: true }]}>
                                                        <Input></Input>
                                                    </Item>
                                                    <Item label={t("执行策略")} name="executionFrequency" rules={[{ required: true }]}>
                                                        <Select>
                                                            <Select.Option value="No">{t("不执行")}</Select.Option>
                                                            <Select.Option value="Once">{t("一次")}</Select.Option>
                                                            <Select.Option value="Daily">{t("每天一次")}</Select.Option>
                                                            <Select.Option value="Weekly">{t("每周一次")}</Select.Option>
                                                        </Select>
                                                    </Item>
                                                    <Item label={t("触发场景")} name="triggers">
                                                        <Checkbox.Group>
                                                            <Checkbox value="Startup">开机</Checkbox>
                                                            <Checkbox value="Login">登录</Checkbox>
                                                        </Checkbox.Group>
                                                    </Item>
                                                    <Item label={t("失败重试次数")} name="failedRetryCount" rules={[{ required: true }]}>
                                                        <Select>
                                                            <Select.Option value={0}>0</Select.Option>
                                                            <Select.Option value={1}>1</Select.Option>
                                                            <Select.Option value={2}>2</Select.Option>
                                                            <Select.Option value={3}>3</Select.Option>
                                                        </Select>
                                                    </Item>
                                                    <Item label={t("检查频率")} name="checkFrequency" rules={[{ required: true }]}>
                                                        <Select>
                                                            <Select.Option value={15}>{t("15分钟")}</Select.Option>
                                                            <Select.Option value={30}>{t("30分钟")}</Select.Option>
                                                            <Select.Option value={60}>{t("60分钟")}</Select.Option>
                                                        </Select>
                                                    </Item>
                                                    <Item label={t("自助服务")} name="isSelfService" rules={[{ required: true }]}>
                                                        <Select>
                                                            <Select.Option value={true}>{t("是")}</Select.Option>
                                                            <Select.Option value={false}>{t("否")}</Select.Option>
                                                        </Select>
                                                    </Item>
                                                </Form>
                                            </Modal>
                                        </div>
                                    </>
                                )}
                            </Row>
                        </div>)
                    );
                }}</Translation>)
        );
    }
}
export default connect(mapStatetoProps, {})(MacCommandPolicyIndex);